"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtil = void 0;
exports.StringUtil = new (class {
    constructor() {
        Object.defineProperty(this, "getInitials", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (fullName, fallback = 'A') => {
                if (!fullName)
                    return fallback;
                const [firstName, ...rest] = fullName.split(' ');
                const lastName = rest.join(' ');
                if (!firstName && !lastName)
                    return fallback;
                const firstNameLetter = firstName?.[0] || '';
                const lastNameLetter = lastName?.[0] || '';
                return firstNameLetter.toUpperCase() + lastNameLetter.toUpperCase();
            }
        });
    }
})();
